import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  border-radius: 4px;
  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);

  h3 {
    font-size: 22px;
  }

  img {
    display: block;
    max-height: 80px;
    margin: 15px auto;
  }

  & > p {
    text-align: center;
    margin: 15px 0;
  }
`;

export const ButtonRow = styled.div`
  display: flex;
  gap: 15px;
`;
